import { RootState } from '../types/store-types';

export const selectOnboarding = (state: RootState) => {
  return state.onboarding;
};
